import { useEffect, useState } from "react";
import api from "../../../../api/api";
import { useNavigate } from "react-router-dom";

export default function LegalEntityShipmentsPage() {
    const [shipments, setShipments] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        api.get("/shipment/my").then((res) => {
            setShipments(res.data);
        });
    }, []);

    return (
        <div className="max-w-4xl mx-auto p-6 bg-white rounded shadow">
            <h2 className="text-xl font-bold mb-4">My Shipments</h2>

            {shipments.map((s) => (
                <div key={s.id} className="border p-3 mb-2">
                    <p>Tracking: {s.trackingNumber}</p>
                    <p>Status: {s.status}</p>

                    <button
                        className="text-blue-600"
                        onClick={() =>
                            navigate(`/payments/create/${s.id}`)
                        }
                    >
                        Pay
                    </button>
                </div>
            ))}
        </div>
    );
}